// Masifi: es/en only (2026-06-16, config/initializers/masifi/masifi_languages.rb); withMasifi = runtime brand.
import { withMasifi } from 'shared/i18n/masifi/masifiOverlay';
import en from './locale/en.json';
import es from './locale/es.json';

export default withMasifi({ en, es });
